<template>
  <div class="main-content mangoUsers">
    <EmptyModal
      v-if="modalData"
      ref="emptyModal"
      :onModalClose="onModalClose"
      :onModalAccept="updatePhoneSettings"
      :modalData="modalData"
    >
      <slot>
        <div>
          <div class="flex">
            <div class="form-group">
              <label for="">Выбор менеджера</label>
              <select class="form-control" v-model="selectedRecord.managerId">
                <option v-for="manager in managers" :value="manager.id">{{
                  manager.name
                }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="">Выбор проекта</label>
              <select class="form-control" v-model="selectedRecord.projectId">
                <option v-for="project in $AllProjects" :value="project.id">{{
                  project.name
                }}</option>
                <option value="0">Все проекты</option>
              </select>
            </div>
          </div>

          <div>
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th>ID линии</th>
                  <th>Номер линии</th>
                  <th>Описание линии</th>
                  <th>Название для менеджера</th>
                  <th>Город</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(line, index) in selectedRecord.activatedLines"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ line.line_id }}</td>
                  <td>{{ line.number }}</td>
                  <td>{{ line.schema_name }}</td>
                  <td>
                    <input class="form-control" v-model="line.phone_title" />
                  </td>
                  <td>
                    <select class="form-control" v-model="line.city_id">
                      <option value="0">Не использовать</option>
                      <option
                        v-for="(city, ind) in $AllCities"
                        :key="ind"
                        :value="city.id"
                        >{{ city.name }}</option
                      >
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </slot>
    </EmptyModal>

    <div class="card">
      <div class="card-header">
        <h5>SIP Пользователи Mango</h5>
      </div>
      <div class="card-body">
        <pulse-loader
          :loading="loading"
          :color="loadingColor"
          class="text-center"
        />

        <table class="table table-sm table-hover" v-if="!loading">
          <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Внутренний</th>
              <th>Менеджер</th>
              <th>Исходящая линия</th>
              <th>Прикрепленные SIP</th>
              <th>Входит в гурппы</th>
            </tr>
          </thead>
          <thead>
            <template v-for="acc in mangoAccounts">
              <tr class="account_line">
                <td colspan="10">
                  ({{ acc.id }}) Аккаунт:
                  <strong
                    >{{ acc.login }} (АТС:{{ acc.ats_num }})
                    {{ acc.project_name }}</strong
                  >
                </td>
              </tr>
              <template v-if="records[acc.id].error">
                <tr>
                  <td colspan="10">{{ records[acc.id].error }}</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(record, index) in records[acc.id].users">
                  <td>{{ record.general.user_id }}</td>
                  <td>{{ record.general.name }}</td>
                  <td>
                    <div class="flex justify-content-between">
                      <span class="margin_auto line_id">{{
                        record.telephony.extension
                      }}</span>
                      <span
                        class="margin_auto p-l-5"
                        v-if="
                          managersPhones[acc.id] &&
                            managersPhones[acc.id][record.telephony.extension]
                        "
                        >{{
                          managersPhones[acc.id][record.telephony.extension]
                            .user.name
                        }}</span
                      >
                      <button
                        @click="openPhoneSettings(acc, record)"
                        type="button"
                        class="btn btn-xs btn-info"
                      >
                        <i class="icon-fa icon-fa-edit"></i>
                      </button>
                    </div>
                  </td>
                  <td>{{ appointedManager(record) }}</td>
                  <td>{{ record.telephony.outgoingline }}</td>
                  <td>
                    <div v-for="number in record.telephony.numbers">
                      {{ number.number }}
                    </div>
                  </td>
                  <td>
                    <span v-for="(group, ind) in record.groups"
                      >{{ ind !== 0 ? ", " : "" }}{{ group }}</span
                    >
                  </td>
                </tr>
                <tr class="account_line">
                  <td colspan="10">Подключенные линии:</td>
                </tr>
                <tr v-for="(line, ind) in lines[acc.id].lines">
                  <td>{{ line.line_id }}</td>
                  <td>{{ line.schema_name }}</td>
                  <td colspan="2">{{ line.number }}</td>
                </tr>
              </template>
              <template
                v-if="groups[acc.id].groups && groups[acc.id].groups.length"
              >
                <tr class="account_line">
                  <td colspan="10">Группы:</td>
                </tr>
                <tr v-for="(group, ind) in groups[acc.id].groups">
                  <td>{{ ind + 1 }}</td>
                  <td>{{ group.name }}</td>
                  <td>{{ group.id }}</td>
                  <td>{{ group.line_id }}</td>
                  <td>
                    <div v-for="operator in group.operators">
                      id: {{ operator.id }} - {{ operator.name }} (очередь:
                      {{ operator.order }})
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import EmptyModal from "../../components/modals/EmptyModal";
// import speakeasy from "speakesy";
// const authenticator = require("authenticator");
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ru";

export default {
  title: "Mango пользователи",
  components: {
    VueLadda,
    EmptyModal,
    DatePicker
  },
  data() {
    return {
      open: true,
      date: new Date(),
      loading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      mangoAccounts: [],
      records: {},
      groups: {},
      lines: {},
      managersPhones: {},
      managers: [],
      modalData: null,
      selectedRecord: null,
      updateData: {
        title: "",
        managerId: null,
        cityId: null,
        projectId: null
      }
    };
  },
  computed: {
    $AllCities() {
      return this.$store.getters["platform/cities"];
    },
    $AllProjects() {
      const stores = this.$store.getters["platform/projects"].filter(
        s => s.id
      );
      return _.orderBy(stores, "id");
    }
  },
  async mounted() {
    await this.getMangoUsers();
    const secret = "dsz7 vsam j7lg i7xo qyma ilm2 idq7 7m5p";
    // const formattedKey = authenticator.generateKey();
    // "acqo ua72 d3yf a4e5 uorx ztkh j2xl 3wiz"
    // const formattedToken = authenticator.generateToken(secret);
    // console.log(formattedToken);
  },
  methods: {
    appointedManager(record) {
      const appMan = this.managersPhones.find(
        m => m.sip_id === record.general.user_id
      );
      return appMan ? appMan.user.name : "";
    },
    async getMangoUsers() {
      this.loading = true;
      let { data } = await api.index("/telephony/getMangoUsers");
      if (data.success) {
        this.records = data.records;
        this.groups = data.groups;
        this.lines = data.lines;
        this.managersPhones = data.managersPhones;
        this.managers = _.orderBy(data.managers, "name");
        this.mangoAccounts = data.accounts;
      } else {
        this.Toast.fire({
          type: "warning",
          title: data.message || "Ошибка"
        });
      }
      this.loading = false;
    },
    openPhoneSettings(acc, record) {
      this.selectedRecord = {
        mangoId: acc.id,
        managerId: null,
        projectId: null,
        extension: record.telephony.extension,
        sipId: record.general.user_id,
        activatedLines: {}
      };
      // console.log(this.managersPhones);
      const userRecords = this.managersPhones.reduce((accum, m) => {
        if (m.mango_acc_id === acc.id && m.sip_id === record.general.user_id) {
          this.selectedRecord.managerId = m.user_id;
          this.selectedRecord.projectId = m.project_id;
          accum[m.line_id] = { ...m };
        }
        return accum;
      }, {});

      this.selectedRecord.activatedLines = this.lines[
        this.selectedRecord.mangoId
      ].lines.reduce((acc, l) => {
        let recordPhone = userRecords[l.line_id];
        if (!recordPhone) recordPhone = {};
        acc.push({ ...l, phone_title: null, city_id: 0, ...recordPhone });
        return acc;
      }, []);
      this.modalData = {
        header: `Настройка исходящих пользователя ${record.general.name}`
      };
    },
    async updatePhoneSettings() {
      if (!this.selectedRecord.managerId) {
        this.Toast.fire({
          type: "warning",
          title: "Выберите менджера"
        });
        return;
      }
      if (!this.selectedRecord.projectId) {
        this.Toast.fire({
          type: "warning",
          title: "Выберите проект"
        });
        return;
      }
      this.$refs.emptyModal.acceptBtnLoading = true;
      let { data } = await api.post("/telephony/updatePhoneMango", {
        records: this.selectedRecord,
        sips: Object.keys(this.records).reduce((acc, accId) => {
          Object.keys(this.records[accId].users).map(u => {
            const user = this.records[accId].users[u];
            user.telephony.numbers.map(n => {
              acc.push({
                mango_acc: accId,
                extension: user.telephony.extension,
                sip: n.number || null,
                out_line: user.telephony.outgoingline || null
              });
            });
          });
          return acc;
        }, [])
      });
      if (data.success) {
        this.managersPhones = data.records;
        this.modalData = null;
        this.Toast.fire({
          type: "success",
          title: "Сохранено"
        });
      } else {
        this.Toast.fire({
          type: "warning",
          title: data.message || "Ошибка сохранения"
        });
      }
      this.$refs.emptyModal.acceptBtnLoading = false;
    },
    onModalClose() {
      this.modalData = null;
    },
    disabledDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    }
  }
};
</script>

<style scoped>
.line_id {
  min-width: 30px;
}

.margin_auto {
  margin: auto 0;
}

button i {
  text-align: center;
}

.account_line {
  background-color: #e9e9ff;
}
</style>
